import notificationsApi from 'services/api/notifications'

import {
  GET_NOTICATIONS_FAILED,
  GET_NOTICATIONS_STARTED,
  GET_NOTICATIONS_SUCCESS,
  GET_NOTIFICATION_PREFERENCES_FAILED,
  GET_NOTIFICATION_PREFERENCES_STARTED,
  GET_NOTIFICATION_PREFERENCES_SUCCESS,
  PUSH_NEW_NOTIFICATION
} from './actionTypes'

const notificationTypes = {
  NegativeReview: 'Low rating reviews',
  WaitingClientChatExists: 'New chat message'
}

function fillBlanksInApiData(result) {
  return Object.keys(notificationTypes).reduce(
    (prev, curr) => [
      ...prev,
      {
        kind: curr,
        subsidiaries:
          result && result.items.find(o => o.kind === curr)
            ? result.items.find(o => o.kind === curr).subsidiaries
            : []
      }
    ],
    []
  )
}

export const getNotifications = () => {
  return async dispatch => {
    dispatch({
      type: GET_NOTICATIONS_STARTED
    })

    try {
      const response = await notificationsApi.get()

      dispatch({
        type: GET_NOTICATIONS_SUCCESS,
        payload: response.alerts
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: GET_NOTICATIONS_FAILED,
        payload: err.toString()
      })
    }
  }
}

export const pushNewNotification = notification => ({
  type: PUSH_NEW_NOTIFICATION,
  payload: notification
})

export const gotNotificationPreferences = data => ({
  type: GET_NOTIFICATION_PREFERENCES_SUCCESS,
  payload: fillBlanksInApiData(data)
})

export const getNotificationPreferences = () => {
  return async dispatch => {
    dispatch({
      type: GET_NOTIFICATION_PREFERENCES_STARTED
    })

    try {
      const response = await notificationsApi.getPreferences()
      dispatch(gotNotificationPreferences(response))
    } catch (err) {
      dispatch({
        type: GET_NOTIFICATION_PREFERENCES_FAILED,
        payload: err
      })
    }
  }
}
